<mat-card>
  <form [formGroup]="form" (ngSubmit)="save()">
    <mat-card-header>
      <mat-card-title [translate]="'accounts/edition/information'"></mat-card-title>
    </mat-card-header>

    <p class="single-line">
      <mat-form-field>
        <mat-label [translate]="'common/name'"></mat-label>
        <input type="text" matInput formControlName="name" data-testid="account-name" />
      </mat-form-field>
      <button
        *ngIf="
          !account?.authorized_user?.details || !account.authorized_user.details.has_profile_picture;
          else removePicture
        "
        class="upload-picture"
        type="button"
        mat-raised-button
        (click)="uploadFile.click()">
        <span [translate]="'settings/account/profile/picture/add-new'"></span>
      </button>
      <ng-template #removePicture>
        <img class="site-img-thumb" [appJwtSrc]="account?.authorized_user?.details.avatarUrl" />
        <button
          data-testid="delete-picture"
          class="delete-picture"
          type="button"
          mat-raised-button
          (click)="deletePicture()">
          <span [translate]="'settings/account/profile/picture/remove-existing'"></span>
        </button>
      </ng-template>
      <input
        #uploadFile
        type="file"
        accept="image/*"
        (change)="uploadAccountPicture($event)"
        fileread="filenames.picture"
        hidden />
    </p>
    <div *ngFor="let testLink of account?.testUrls" class="test-link">
      <div [translate]="'accounts/edition/test-link/' + testLink.name"></div>
      <div *ngIf="testLink.url; else noTestLink">
        <a data-testid="account-test-link" href="{{ testLink.url }}" target="_blank">
          {{ testLink.url }}
        </a>
        <button
          *ngIf="account?.type === whatsappAccountType"
          mat-raised-button
          type="button"
          class="generate-qr-code"
          [attr.aria-label]="'accounts/edition/test-link/generate-qr-code' | translate"
          (click)="generateQrCode(generateQRCodeTemplateRef)">
          <mat-icon>qr_code_2</mat-icon>&nbsp;
          <span translate="accounts/edition/test-link/generate-qr-code"></span>
        </button>

        <ng-template #generateQRCodeTemplateRef>
          <app-generate-qr-code [data]="account.test_url"></app-generate-qr-code>
        </ng-template>
      </div>
      <ng-template #noTestLink data-testid="no-account-test-link">
        <span [translate]="'accounts/edition/no-test-link'"></span
      ></ng-template>
    </div>

    <p>
      <mat-form-field>
        <mat-label [translate]="'accounts/edition/language'"></mat-label>
        <mat-select formControlName="lang_code">
          <mat-option *ngFor="let language of languages" [value]="language.id">{{ language.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </p>
    <ng-container *ngIf="account?.type === accountsService.twitterSiteType">
      <p>
        <mat-form-field>
          <mat-label [translate]="'account/id/default_reply_as'"></mat-label>
          <mat-select formControlName="default_reply_as">
            <mat-option *ngFor="let site of accountsService.twitterSites" [value]="site.id">{{ site.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </p>
    </ng-container>
    <p>
      <mat-form-field>
        <mat-label [translate]="'accounts/in-group'"></mat-label>
        <mat-select formControlName="site_group_id">
          <mat-option *ngFor="let group of accountsService.eligibleGroups" [value]="group.id">{{
            group.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <div
      class="part-of-waba"
      *ngIf="account?.type === whatsappAccountType && wabaAssociationsMap?.has(account['waba_id'])">
      <div translate="accounts/edition/part-of-waba" class="title">
        <a [href]="whatsappBusinessManagerLink" target="_blank">
          &nbsp;<mat-icon class="go-to-waba-link">open_in_new</mat-icon>
        </a>
      </div>
      <div>
        <span translate="accounts/edition/waba-id"></span>
        {{ wabaAssociationsMap.get(account['waba_id']).id }}
      </div>
      <div>
        <span translate="accounts/edition/waba-name"></span>
        {{ wabaAssociationsMap.get(account['waba_id']).label }}
      </div>
      <div *ngIf="account['quality_score']">
        <span translate="accounts/edition/quality-score"> </span>
        <span [matTooltip]="whatsappCloudApiQualityScoreTooltips[account['quality_score']]">
          {{ 'accounts/edition/quality-score/' + account['quality_score'] | translate }}
        </span>
      </div>
      <div *ngIf="account['status']">
        <span translate="accounts/edition/status"> </span>
        <span [matTooltip]="whatsappCloudApiStatusTooltips[account['status']]">
          {{ 'accounts/edition/status/' + account['status'] | translate }}
        </span>
      </div>
      <div *ngIf="account['data_localization_region']">
        <span translate="accounts/edition/data_localization_region"> </span>
        {{ account['data_localization_region'] }}
      </div>
    </div>

    <p>
      <mat-slide-toggle color="primary" formControlName="enable_alert_email">
        <span [translate]="'accounts/edition/enable_alert_email'"></span>
      </mat-slide-toggle>
    </p>

    <div class="whatsapp-cloud-api-messaging-limit-container" *ngIf="isCloudAPI">
      <div class="whatsapp-cloud-api-messaging-limit">
        <div
          *ngFor="let limit of whatsappCloudApiMessagingLimits"
          class="limit-wrapper"
          [class.selected]="limit === whatsappCloudApiMessagingLimit">
          <div class="placeholder">
            {{ 'accounts/edition/messaging-limit/' + limit | translate }}
          </div>
          <div class="current">
            <span class="header-badge" translate="accounts/edition/messaging-limit/current"></span>
            <span class="limit"> {{ 'accounts/edition/messaging-limit/' + limit | translate }}</span>
            <span class="description" translate="accounts/edition/messaging-limit/description"></span>
          </div>
        </div>
      </div>
    </div>

    <mat-card-actions>
      <button type="submit" mat-raised-button [disabled]="form.pristine || form.invalid" color="primary">
        <span [translate]="'save'"></span>
      </button>
    </mat-card-actions>
  </form>
</mat-card>
